export function humanizeFormattedTimestamp(timestamp, defaultValue) {
  if (timestamp === undefined) {
    return defaultValue || '-';
  } else {
    return timestamp
      .replace('T', ' ')
      .replace('Z', ' UTC');
  }
}
